import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';

// containers
import PublicLayout from '../layouts/PublicLayout';
import ResetPasswordForm from '../components/Auth/ResetPasswordForm';

// app routes
import appRoutes from '../routes/appRoutes';

import { resetPassword } from '../api/auth';
import { useNavigate, useParams } from 'react-router-dom';
import ResetPasswordModal from './ResetPasswordModal';

const ResetPassword = () => {
  const { token } = useParams();
  const [isEmailResetModal, setIsEmailResetModal] = useState(false);
  const [modalText, setModalText] = useState('');
  const navigate = useNavigate();

  const handleResetPasswordForm = async (formVal) => {
    try {
      await resetPassword({ token, ...formVal });
      setIsEmailResetModal(true);
      setModalText(null);
    } catch (error) {
      setIsEmailResetModal(true);
      setModalText('Failed to reset password, try again');
    }
  };

  const handleModalClose = () => {
    setIsEmailResetModal(false);
    navigate(appRoutes.login);
  };

  return (
    <PublicLayout>
      <Box width={1}>
        <Typography variant="h3" mb={1}>
          Reset Password
        </Typography>
        <Typography paragraph>
          Please enter your new and confirm password to reset password
        </Typography>
      </Box>
      <Box width={1}>
        <ResetPasswordForm onFormSubmit={handleResetPasswordForm} serverErrorMsg="" />
      </Box>
      <ResetPasswordModal
        open={isEmailResetModal}
        onClose={handleModalClose}
        modalText={modalText}
      />
    </PublicLayout>
  );
};

export default ResetPassword;
